import { getType } from '@reduxjs/toolkit';
import { call, put, takeLatest } from 'redux-saga/effects';

import { IHealthcareApi, IPhysiologicalData } from '../../interfaces';
import { convertToError } from '../../utils';
import * as actions from './actions';

function* fetchPhysiologicalData(api: IHealthcareApi, action: ReturnType<typeof actions.fetchPhysiologicalData>) {
  const { rangeType, dateFrom, dateTo, patient } = action.payload;

  try {
    const physiologicalData: IPhysiologicalData = yield call(
      api.fetchPhysiologicalData,
      rangeType,
      dateFrom,
      dateTo,
      patient.id,
    );

    yield put(actions.fetchPhysiologicalDataSucceeded({ physiologicalData, patient, rangeType }));
  } catch (e) {
    yield put(actions.fetchPhysiologicalDataFailed(convertToError(e)));
  }
}

function* fetchCuffMeasurements(api: IHealthcareApi, action: ReturnType<typeof actions.fetchCuffMeasurements>) {
  const { dateFrom, dateTo, patientId } = action.payload;

  try {
    const physiologicalData: IPhysiologicalData = yield call(api.fetchCuffMeasurements, dateFrom, dateTo, patientId);

    yield put(actions.fetchCuffMeasurementsSucceeded({ physiologicalData }));
  } catch (e) {
    yield put(actions.fetchCuffMeasurementsFailed(convertToError(e)));
  }
}

export function* physiologicalDataSaga(api: IHealthcareApi) {
  yield takeLatest(getType(actions.fetchPhysiologicalData), fetchPhysiologicalData, api);
  yield takeLatest(getType(actions.fetchCuffMeasurements), fetchCuffMeasurements, api);
}
